/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 12:08
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

// TODO: @HTML5 - Missing UncaughtErrorEvent
// import UncaughtErrorEvent = createjs.UncaughtErrorEvent;

// ONLY USABLE FOR FP 10.3 AND HIGHER!!!!
export class UncaughtExceptionErrorLOFactory extends BasicLogObjectFactory {
    public static UNDEFINED_ERROR: number = 2001;

    private static UNCAUGHT_EXCEPTION: number = 2;

    private static PARAM_EVENT_ERROR_TYPE: string = "eventErrorType";
    private static PARAM_EVENT_ERROR_ID: string = "eventErrorId";
    private static PARAM_EVENT_ERROR_TARGET: string = "eventErrorTarget";
    private static PARAM_EVENT_ERROR_TEXT: string = "eventErrorText";
    private static PARAM_EVENT_ERROR_STACKTRACE: string = "eventErrorStackTrace";

    private _event: any; // UncaughtErrorEvent
    private _stackLines: any[];

    constructor(subErrorId: number, event: any, stackLines: any[]) {
        super();

        this._subErrorId = subErrorId;
        this._stackLines = stackLines;
        this._event = event;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, UncaughtExceptionErrorLOFactory.UNCAUGHT_EXCEPTION.toString());

        lo.logData.set(UncaughtExceptionErrorLOFactory.PARAM_EVENT_ERROR_TYPE, this._event.error);
        lo.logData.set(UncaughtExceptionErrorLOFactory.PARAM_EVENT_ERROR_ID, this._event.errorID);
        lo.logData.set(UncaughtExceptionErrorLOFactory.PARAM_EVENT_ERROR_TARGET, this._event.target);
        lo.logData.set(UncaughtExceptionErrorLOFactory.PARAM_EVENT_ERROR_TEXT, this._event.text);
        lo.logData.set(UncaughtExceptionErrorLOFactory.PARAM_EVENT_ERROR_STACKTRACE, this._stackLines[0] + " " + this._stackLines[1]);

        return lo;
    }
}
